import MenuComponent from '@/components/MenuComponent'
import MenuConnexion from '@/components/MenuConnexion'
import BlocAuthenticated from '@/components/BlocAuthenticated'
import { UpdateUser } from '@/models/user.model'

export default {
  props: ['editedUser'],
  components: {
    MenuComponent,
    MenuConnexion,
    BlocAuthenticated
  },
  data () {
    return {
      possibleLocalGroups: this.$store.state.user.user.possibleGroupesList,
      civilityValues: ['M.', 'Mme', 'Melle'],
      selectedCivility: '',
      selectedGroup: {},
      validationMessage: [],
      updateUserBean: new UpdateUser(),
      restrictionFilters: ['', 'ENTITY_NAME', 'AGENCY_CODE', 'SIRET'],
      firstRestriction: {},
      secondRestriction: {},
      thirdRestriction: {}
    }
  },
  beforeCreate () {
    this.$store.state.filArianePage = 'Modification de l\'utilisateur'
    this.$store.state.filArianeMiddlePage = 'Liste des utilisateurs'
    this.$store.state.filArianeMiddleRouterLink = 'administration/user/list'
  },
  mounted () {
    var self = this
    $( function () {
      $('#datelogin').datepicker({
        onSelect: function (dateText) {
          self.editedUser.dateEnvoiLogin = dateText
        }
      })
      $('#dateacces').datepicker({
        onSelect: function (dateText) {
          self.editedUser.dateEnvoiPassword = dateText
        }
      })
    })

    if (!this.editedUser) {
      this.$router.push({ name: 'administration/user/list' })
    }
    if (this.editedUser) {
      if (this.editedUser.civility === 'MONSIEUR') {
        this.selectedCivility = 'M.'
      }
      if (this.editedUser.civility === 'MADEMOISELLE') {
        this.selectedCivility = 'Melle'
      }
      if (this.editedUser.civility === 'MADAME') {
        this.selectedCivility = 'Mme'
      }
      for (let index = 0; index < this.possibleLocalGroups.length; index++) {
        if (this.possibleLocalGroups[index].name === this.editedUser.groupe.name) {
          this.selectedGroup = this.possibleLocalGroups[index]
        }
      }
      // Formattage de la date pour affichage dans les input date
      var moment = require('moment')
      if (this.editedUser.dateEnvoiLogin) {
        if (this.editedUser.dateEnvoiLogin === 'Invalid date') {
          this.editedUser.dateEnvoiLogin = null
        } else {
          this.editedUser.dateEnvoiLogin = moment(this.editedUser.dateEnvoiLogin).format('YYYY-MM-DD')
        }
      }

      if (this.editedUser.dateEnvoiPassword) {
        if (this.editedUser.dateEnvoiPassword === 'Invalid date') {
          this.editedUser.dateEnvoiPassword = null
        } else {
          this.editedUser.dateEnvoiPassword = moment(this.editedUser.dateEnvoiPassword).format('YYYY-MM-DD')
        }
      }

      // Chargement RestrictionList
      if (this.editedUser.restrictionsFilter && this.editedUser.restrictionsFilter.restrictionsItemsList && this.editedUser.restrictionsFilter.restrictionsItemsList.length) {
        this.updateUserBean.adminRestricted = true
        this.updateUserBean.restrictionList = this.editedUser.restrictionsFilter.restrictionsItemsList

        for (let index = 0; index < this.updateUserBean.restrictionList.length; index++) {
          if (this.updateUserBean.restrictionList[index].filterName === 'ENTITY_NAME') {
            this.firstRestriction = this.editedUser.restrictionsFilter.restrictionsItemsList[index]
          }
          if (this.updateUserBean.restrictionList[index].filterName === 'AGENCY_CODE') {
            this.secondRestriction = this.editedUser.restrictionsFilter.restrictionsItemsList[index]
          }
          if (this.updateUserBean.restrictionList[index].filterName === 'SIRET') {
            this.thirdRestriction = this.editedUser.restrictionsFilter.restrictionsItemsList[index]
          }
        }
      } else {
        this.updateUserBean.adminRestricted = false
      }

      if (!String.prototype.includes) {
        if (this.editedUser.rmUser && this.editedUser.rmUser.principals.indexOf('LogsAdmin', 0) !== -1) {
          this.updateUserBean.logsAdminAccess = true
        }
      } else {
        if (this.editedUser.rmUser && this.editedUser.rmUser.principals.includes('LogsAdmin')) {
          this.updateUserBean.logsAdminAccess = true
        }
      }
    }
  },
  methods: {
    editUser () {
      this.validationMessage = []
      this.editedUser.groupe = this.selectedGroup
      this.editedUser.updateUser = this.$store.state.user.user.login
      this.updateUserBean.updateUser = this.$store.state.user.user.login
      this.updateUserBean.id = this.editedUser.personneId
      this.updateUserBean.restrictionList = []

      if (!this.editedUser.groupe || this.editedUser.groupe === '' || this.editedUser.groupe.name === 'Sélectionner une valeur') {
        this.validationMessage[0] = 'You must provide a value for Group.'
      } else {
        this.updateUserBean.groupe = this.editedUser.groupe
      }
      this.updateUserBean.civilite = this.selectedCivility
      if (!this.editedUser.firstName || this.editedUser.firstName === '') {
        this.validationMessage[1] = 'You must provide a value for First Name.'
      } else {
        this.updateUserBean.prenom = this.editedUser.firstName
      }
      if (!this.editedUser.lastName || this.editedUser.lastName === '') {
        this.validationMessage[2] = 'You must provide a value for Last Name.'
      } else {
        this.updateUserBean.nom = this.editedUser.lastName
      }
      this.updateUserBean.telephone = this.editedUser.phone
      this.updateUserBean.fax = this.editedUser.fax
      this.updateUserBean.emailPro = this.editedUser.emailPro
      if (!this.editedUser.address || this.editedUser.address === '') {
        this.validationMessage[3] = 'You must provide a value for Address.'
      } else {
        this.updateUserBean.adresse = this.editedUser.address
      }
      this.updateUserBean.adresseComplement = this.editedUser.addressComplement
      if (!this.editedUser.zipCode || this.editedUser.zipCode === '') {
        this.validationMessage[4] = 'You must provide a value for Postal code.'
      } else {
        this.updateUserBean.codePostal = this.editedUser.zipCode
      }
      if (!this.editedUser.city || this.editedUser.city === '') {
        this.validationMessage[5] = 'You must provide a value for Town.'
      } else {
        this.updateUserBean.ville = this.editedUser.city
      }
      if (!this.editedUser.country || this.editedUser.country === '') {
        this.validationMessage[6] = 'You must provide a value for Country.'
      } else {
        this.updateUserBean.pays = this.editedUser.country
      }
      if (!this.editedUser.dateEnvoiLogin === 'Invalid date') {
        this.updateUserBean.dateEnvoieLogin = this.editedUser.dateEnvoiLogin
      }
      if (!this.editedUser.dateEnvoiePassword === 'Invalid date') {
        this.updateUserBean.dateEnvoiePassword = this.editedUser.dateEnvoiPassword
      }
      this.updateUserBean.nbEssaisQuestionSecrete = this.editedUser.secretResponseTryNbr

      if (!this.updateUserBean.restrictionList) {
        this.updateUserBean.restrictionList = []
      }

      this.checkRestrictionsAdmin()

      if (!this.validationMessage.length) {
        this.loading = true
        this.$store.dispatch('user/editUser', this.updateUserBean).then(
          response => {
            this.loading = false
            this.editedUser.logsAdminAccess = this.updateUserBean.logsAdminAccess

            if (this.editedUser.logsAdminAccess) {
              if (this.editedUser.rmUser.principals.indexOf('LogsAdmin', 0) === -1) {
                this.editedUser.rmUser.principals.push('LogsAdmin')
              }
            } else {
              var index = this.editedUser.rmUser.principals.indexOf('LogsAdmin', 0)
              if (index > -1) {
                this.editedUser.rmUser.principals.splice(index, 1)
              }
            }

            if (this.updateUserBean.adminRestricted) {
              this.editedUser.adminRestricted = this.updateUserBean.adminRestricted

              if (this.updateUserBean.restrictionList && this.updateUserBean.restrictionList.length) {
                this.editedUser.restrictionsFilter.restrictionsItemsList = this.updateUserBean.restrictionList
              } else {
                this.editedUser.restrictionsFilter.restrictionsItemsList = []
              }
            } else {
              this.editedUser.restrictionsFilter.restrictionsItemsList = []
            }
            this.$router.push({ name: 'administration/user/view', params: { 'editedUser': this.editedUser } })
          },
          error => {
            this.loading = false
            this.errorMessage = error.response
          }
        )
      }
    },
    checkRestrictionsAdmin () {
      // Gestion des restrictions d'acces
      if (this.firstRestriction.filterName && this.firstRestriction.restrictionItemsBase) {
        if (this.updateUserBean.restrictionList[0]) {
          this.updateUserBean.restrictionList[0] = this.firstRestriction
        } else {
          this.updateUserBean.restrictionList.push(this.firstRestriction)
        }
      }
      if (this.secondRestriction.filterName && this.secondRestriction.restrictionItemsBase) {
        if (this.updateUserBean.restrictionList[1]) {
          this.updateUserBean.restrictionList[1] = this.secondRestriction
        } else {
          this.updateUserBean.restrictionList.push(this.secondRestriction)
        }
      }
      if (this.thirdRestriction.filterName && this.thirdRestriction.restrictionItemsBase) {
        if (this.updateUserBean.restrictionList[2]) {
          this.updateUserBean.restrictionList[2] = this.thirdRestriction
        } else {
          this.updateUserBean.restrictionList.push(this.thirdRestriction)
        }
      }

      if (!this.updateUserBean.restrictionList.length) {
        this.editedUser.adminRestricted = false
        this.updateUserBean.adminRestricted = false
        this.updateUserBean.restrictionList = []
      }

      this.editedUser.restrictionsFilter = {}
      this.editedUser.restrictionsFilter.restrictionsItemsList = this.updateUserBean.restrictionList
    },
    getCivility () {
      if (this.editedUser.civility === 'MONSIEUR') {
        return 'M.'
      }
      if (this.editedUser.civility === 'MADEMOISELLE') {
        return 'Melle'
      }
      if (this.editedUser.civility === 'MADAME') {
        return 'Mme'
      }
    },
    format_date (value) {
      var moment = require('moment')
      if (value) {
        return moment(value).format('DD/MM/YYYY HH:mm:ss')
      }
    }
  }
}
